import { useState } from 'react';
import { useLookups } from '../context/LookupsContext';
import { clientsApi } from '../api';
import he from '../i18n/he';
import Modal from './Modal';
import { TextInput, Select, ColorInput } from './Form';
import { ErrorText } from './Loader';
import ContactsEditor from './ContactsEditor';
import { initialContacts, contactsPayload, contactsValid } from '../utils/contacts';

export default function ClientModal({ client, onClose, onSaved }) {
  const lookups = useLookups();
  const isNew = !client.id;
  const [form, setForm] = useState({
    name: client.name || '',
    payment_method: client.payment_method || 'transfer',
    payment_terms: client.payment_terms || 'net',
    notes: client.notes || '', // carried through so editing doesn't wipe it
    color: client.color || '', // empty on a new client → server assigns a default
  });
  // The contact people (071) — the whole set, edited here on create and on edit alike.
  const [contacts, setContacts] = useState(() => initialContacts(client));
  const [error, setError] = useState(null);
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async () => {
    try {
      // Omit an untouched colour so the server can auto-assign a stable default.
      const payload = { ...form, contacts: contactsPayload(contacts) };
      if (!payload.color) delete payload.color;
      if (isNew) await clientsApi.create(payload);
      else await clientsApi.update(client.id, payload);
      onSaved();
    } catch (e) {
      setError(e);
    }
  };

  return (
    <Modal
      title={isNew ? he.clients.newClient : client.name}
      onClose={onClose}
      onSave={submit}
      saveDisabled={!contactsValid(contacts)}
    >
      <TextInput label={he.clients.name} value={form.name} onChange={set('name')} />
      <ContactsEditor contacts={contacts} onChange={setContacts} />
      <Select
        label={he.clients.method}
        value={form.payment_method}
        onChange={set('payment_method')}
        options={lookups.methodOptionsFor(form.payment_method)}
      />
      <Select
        label={he.clients.terms}
        value={form.payment_terms}
        onChange={set('payment_terms')}
        options={lookups.termOptionsFor(form.payment_terms)}
      />
      <ColorInput label={he.clients.color} value={form.color || '#3b82f6'} onChange={set('color')} />
      {error && <ErrorText error={error} />}
    </Modal>
  );
}
